import React from "react"

const Tag = ({ tag, size, ...props }) => {
    let className = "tag"

    if (size != '') {
        className += ` tag--${size} `
    }

    if (tag.type === "Default") {
        className += " tag--highlight"
    }

    if (tag.type === "Info") {
        //ToDo: change classname
        className += " tag--highlight tag--highlight--blue"
    }

    if (tag.type === "Success") {
        //ToDo: change classname
        className += " tag--highlight tag--highlight--green"
    }

    if (tag.type === "Warning") {
        //ToDo: change classname
        className += " tag--highlight tag--highlight--orange"
    }
    if (tag.type === "Event") {
        // Nuevo tipo para tus eventos con fondo semi-transparente
        className += " tag--event-transparent"
    }

    return <div className={className} {...props}>{tag.name}</div>
}

export default Tag
